<template>
  <div>
    <div class="col">
      <div class="row">
        <div class="col-md-4">
          <Notifications />
          <InternalOrdersCard class="card mb-3" title="Interni nalogi" subTitle="Accepted, zame" :ownerID="worker.id.value" statuses="Accepted" v-if="worker.id.value" />
        </div>
        <div class="col-md-4">
          <WarehouseTransfersCard class="card mb-3" :toWarehouseID="worker.activeWarehouse?.value?.id" statuses="New,MovementOrder" subTitle="Zame, novi"  />
        </div>
        <div class="col-md-4">
          <ProductionOrdersCard class="card mb-3" :ownerID="worker.id.value" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <ServiceOrdersCard class="card mb-3" title="Servisni nalogi"
            subTitle="Triage,Accepted,InProgress + zame"
            statuses="Triage,Accepted,InProgress"
            :ownerID="worker.id.value" />

          <DevicesCard class="card mb-3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useWorker } from "../composition-api/useWorker"
import WorkersCard from "../components/WorkersCard.vue"
import Notifications from "../components/Notifications.vue"
import WarehouseTransfersCard from "../components/WarehouseTransfersCard.vue"
import InternalOrdersCard from "../components/InternalOrdersCard.vue"
import ProductionOrdersCard from "../components/ProductionOrdersCard.vue"
import ServiceOrdersCard from "../components/ServiceOrdersCard.vue"

defineOptions({ name: "HomeWarehouseManager" })

const { worker } = useWorker()
</script>
